<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addOpen()">新建补贴项目</el-button>
        <el-select v-fixZoom v-model="filterType" placeholder="请选择" style="width: 130px">
          <el-option v-for="item in filterTypeArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-input v-model="filterText" prefix-icon="el-icon-search" placeholder="请输入" clearable style="width: 250px"></el-input>
        <el-button type="success" @click="getSearchData">查询</el-button>
      </div>
      <div style="max-height: calc(100% - 120px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="补贴人员"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="project"
            label="补贴项目"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column
            label="金额"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.amount}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="发放时间"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.grant_time}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <i title="详情" class="el-icon-view" style="cursor: pointer; font-size: 18px;color: blue" @click="seeOpen(scope.row)"></i>
              <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editOpen(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delOpen(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-subsidy :subsidyObj="subsidyObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-subsidy>
    </el-dialog>
  </div>
</template>

<script>
import {deletesubsidy, querysubsidy} from '../../api/yanglaoyuan/subsidyManage'
import addEditSubsidy from './components/addEditSubsidy'

export default {
  name: 'subsidyManagement',
  components: {addEditSubsidy},
  data () {
    return {
      filterTypeArr: [{id: 1, name: '姓名'}, {id: 2, name: '补贴项目'}],
      filterType: 1,
      filterText: '',
      entityId: 0,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      subsidyObj: {
        openType: 0,
        row: ''
      }
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getSearchData()
  },
  methods: {
    addOpen () {
      this.addEditTitle = '新建补贴项目'
      this.subsidyObj.row = ''
      this.subsidyObj.openType = 1
      this.addEditShow = true
    },
    editOpen (row) {
      this.addEditTitle = '修改补贴项目'
      this.subsidyObj.row = row
      this.subsidyObj.openType = 2
      this.addEditShow = true
    },
    seeOpen (row) {
      this.addEditTitle = '补贴详情'
      this.subsidyObj.row = row
      this.subsidyObj.openType = 0
      this.addEditShow = true
    },
    delOpen (row) {
      this.$confirm('此操作将永久删除该补贴项目【' + row.project + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletesubsidy(data).then(res => {
          this.$notify({title: '成功', message: '成功删除该补贴项目', type: 'success', duration: 2000})
          this.updateTable()
        })
      })
    },

    getSearchData () {
      this.getSubsidyMangeData()
    },
    updateTable () {
      this.getSubsidyMangeData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    // 访问接口
    // 查询补贴
    getSubsidyMangeData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        e_id: this.entityId,
        name: this.filterType === 1 ? this.filterText : '',
        project: this.filterType === 2 ? this.filterText : ''
      }
      querysubsidy(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.subsidy
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/subsidyManagement.vue